import React from 'react'
import { withContentful } from 'components/vendor/Contentful/withContentful'
import ExplorePageLayout from './layouts/ExplorePageLayout'
import { CONTENTFUL_KEYS, EMBED_PARTNERS, EMBED_PRODUCTS } from 'parameters/index'
import MultiProductWidget from 'components/vendor/MultiProductWidget/MultiProductWidget'
import { ExplorePageReduxProps } from 'types/page'

const StudentLoanRefinancePage = ({ articles, getValue }: ExplorePageReduxProps): JSX.Element => (
	<ExplorePageLayout
		articles={articles}
		title={`${getValue(CONTENTFUL_KEYS.PRODUCTS.STUDENT_LOAN_REFINANCE.TITLE.FIRST)} ${getValue(
			CONTENTFUL_KEYS.PRODUCTS.STUDENT_LOAN_REFINANCE.TITLE.SECOND
		)}`}
		description={getValue(CONTENTFUL_KEYS.PRODUCTS.STUDENT_LOAN_REFINANCE.DESCRIPTION)}
		background="/images/explore-illustration.svg"
	>
		<MultiProductWidget product={EMBED_PRODUCTS.LOAN} partner={EMBED_PARTNERS.FIONA_SLR} isExplorePage />
	</ExplorePageLayout>
)

export default withContentful(StudentLoanRefinancePage)
